@if (visit?.ai_derm?.enabled && isVisitSCD() && BOD_3536) {
  <div>
    <ai-derm
      [visit]="visit"
      (reject)="rejectExamPhotos($event)"
      (approve)="approveExamPhotos($event)"
    ></ai-derm>
  </div>
}

@if (!visit?.ai_derm?.enabled || !isVisitSCD()) {
  <div>
    @if (errorMessage) {
      <div class="alert alert-danger">
        <button type="button" class="close" (click)="errorMessage = null">
          <span aria-hidden="true">&times;</span>
        </button>
        {{ errorMessage$ | async }}
      </div>
    }
    @if (photos().length && task) {
      <task-photos
        [photos]="photos()"
        [diagnosis]="diagnosis()"
        [types]="types$ | async"
        [visit]="visit"
        [errorMessage]="errorMessage$ | async"
        (reloaded)="reload()"
        (rejected)="rejectExamPhotos($event)"
        (approved)="approveExamPhotos($event)"
      ></task-photos>
    }
    @if (BOD_858_feature_flag) {
      <div>
        @if (photoStatus) {
          <p>{{ photoStatus }}</p>
        }
        <p>You can request up to 10 photos</p>
        <div>
          <mat-form-field>
            <mat-select placeholder="Select number of exam photos">
              @for (state of states; track state) {
                <mat-option [value]="state" (click)="sendState(state)">
                  {{ state }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <button (click)="openMessageDialog()"
            [disabled]="!state || photoStatus || (errorMessage$ | async)">
            Request {{ state }} Exam Photos
          </button>
        </div>
        <div>
          <button (click)="approveAdditionalExamPhotos()">Approve Photos</button>
        </div>
      </div>
    }
  </div>
}
